/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothCreateDto } from '../../models/booth-create-dto';
import { BoothDto } from '../../models/booth-dto';

export interface FloorPlanAdminControllerCreateBoothV1$Params {
      body: BoothCreateDto
}

export function floorPlanAdminControllerCreateBoothV1(http: HttpClient, rootUrl: string, params: FloorPlanAdminControllerCreateBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
  const rb = new RequestBuilder(rootUrl, floorPlanAdminControllerCreateBoothV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BoothDto>;
    })
  );
}

floorPlanAdminControllerCreateBoothV1.PATH = '/api/v1/floor-plans/admin/booth';
